import React from 'react';
import { Button, KIND, SIZE } from 'baseui/button';
import { LabelSmall } from 'baseui/typography';
import { actionButtonOverrides as buttonOverrides, StickyActionContainer as Container } from '../styled-component-overrides';
type Props = {
  disabledPreviousObject: boolean;
  disabledNextObject: boolean;
  onPreviousObjectClick: () => void;
  onNextObjectClick: () => void;
};
export const ActionPanel = ({
  disabledPreviousObject,
  disabledNextObject,
  onPreviousObjectClick,
  onNextObjectClick
}: Props) => {
  return <Container>
      <Button size={SIZE.small} kind={KIND.tertiary} disabled={disabledPreviousObject} onClick={onPreviousObjectClick} overrides={buttonOverrides}>
        <LabelSmall>Previous Object</LabelSmall>
      </Button>
      <Button size={SIZE.small} kind={KIND.secondary} disabled={disabledNextObject} onClick={onNextObjectClick} overrides={buttonOverrides}>
        <LabelSmall>Next Object</LabelSmall>
      </Button>
    </Container>;
};